import {
  CheckCircleOutlined,
  KeyOutlined,
  PlusCircleOutlined,
  SearchOutlined,
  SecurityScanOutlined,
} from "@ant-design/icons";
import {
  Button,
  Card,
  Col,
  Divider,
  Empty,
  Input,
  Row,
  Space,
  Typography,
} from "antd";
// import axios from "axios";
import { useEffect, useMemo, useState } from "react";
// import { settings } from "../../../../utils/config";
import { useNotify } from "../../../../components/Notification";
// import { baseUrl } from "../../../../components/common/baseUrl";
import { permissionAPIWithErrorHandling } from "../../../../api/admin/permission";
const { Title, Text } = Typography;

const ListPermissionAddToMenu = (props) => {
  const { existedListPermission, onSelectPermission, onRemovePermission } =
    props;
  const notify = useNotify();
  // const hasAccessToken = settings?.getCookie("access_token");

  //#region state
  const [listPermission, setListPermission] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  //#endregion state

  // Filter permissions based on search
  const filteredPermissions = useMemo(() => {
    if (!searchText) return listPermission;
    return listPermission.filter(
      (item) =>
        item.name?.toLowerCase().includes(searchText.toLowerCase()) ||
        item.label?.toLowerCase().includes(searchText.toLowerCase())
    );
  }, [listPermission, searchText]);

  // Statistics
  const stats = useMemo(() => {
    const total = listPermission.length;
    const selected = existedListPermission?.length || 0;
    const available = total - selected;
    const selectedFromFiltered = filteredPermissions.filter((item) =>
      existedListPermission?.some((id) => id === item.id)
    ).length;
    return {
      total,
      selected,
      available,
      selectedFromFiltered,
      filtered: filteredPermissions.length,
    };
  }, [listPermission, existedListPermission, filteredPermissions]);

  //#region function
  const fetchActions = async () => {
    try {
      setIsLoading(true);
      // const url = `${baseUrl}/api/v1/security/permissions/permission-parent`;
      // const response = await axios.get(url, {
      //   headers: {
      //     "Content-Type": "application/json",
      //     Authorization: `Bearer ${hasAccessToken}`,
      //   },
      // });
      
      const response = await permissionAPIWithErrorHandling.permissionParent();

      if (response.data.success && response.data.data) {
        const result = response.data.data;
        setListPermission(result || []);
      }

    } catch (error) {
      notify.error({
        message: "Thất bại",
        description:
          error?.message || "Có lỗi xảy ra khi tải dữ liệu",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleBulkSelect = () => {
    const unselectedItems = filteredPermissions.filter(
      (item) => !existedListPermission?.some((id) => id === item.id)
    );

    if (unselectedItems.length > 0) {
      onSelectPermission(unselectedItems);
    }
  };

  const handleBulkRemove = () => {
    const selectedIds = filteredPermissions
      .filter((item) => existedListPermission?.some((id) => id === item.id))
      .map((item) => item.id);

    if (selectedIds.length > 0) {
      onRemovePermission(selectedIds);
    }
  };
  //#endregion function

  // useEffect
  useEffect(() => {
    fetchActions();
  }, []);

  // Render Permission Card
  const renderPermissionCard = (permission, index) => {
    const isSelected = existedListPermission?.some(
      (item) => item === permission.id
    );

    return (
      <Col xs={24} sm={12} md={8} lg={6} xl={4} key={permission.id}>
        <Card
          hoverable
          size="small"
          onClick={() => {
            if (isSelected) {
              onRemovePermission([permission.id]);
            } else {
              onSelectPermission([permission]);
            }
          }}
          style={{
            height: "200px",
            borderRadius: "12px",
            border: isSelected ? "2px solid #128555" : "1px solid #F1F5F9",
            backgroundColor: isSelected ? "#EAF9F2" : "#ffffff",
            boxShadow: isSelected
              ? "0 4px 12px rgba(82, 196, 26, 0.2)"
              : "0 2px 8px rgba(0,0,0,0.1)",
            transition: "all 0.3s ease",
            position: "relative",
            overflow: "hidden",
            display: "flex",
            flexDirection: "column",
            cursor: "pointer",
            transform: isSelected ? "scale(1.02)" : "scale(1)",
          }}
          bodyStyle={{
            padding: "16px",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            flex: 1,
            textAlign: "center",
          }}
        >
          {/* Hiển thị ID để debug */}
          <div
            style={{
              position: "absolute",
              top: "12px",
              left: "12px",
              fontSize: "10px",
              color: "#999",
            }}
          >
            ID: {permission.id}
          </div>

          {/* Status Badge */}
          <div style={{ position: "absolute", top: "12px", right: "12px" }}>
            {isSelected ? (
              <CheckCircleOutlined
                style={{
                  fontSize: "20px",
                  color: "#128555",
                  backgroundColor: "#ffffff",
                  borderRadius: "50%",
                  padding: "2px",
                }}
              />
            ) : (
              <PlusCircleOutlined
                style={{
                  fontSize: "20px",
                  color: "#CBD5E1",
                  backgroundColor: "#ffffff",
                  borderRadius: "50%",
                  padding: "2px",
                }}
              />
            )}
          </div>

          {/* Content - giữ nguyên phần còn lại */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              height: "100%",
            }}
          >
            {/* Icon */}
            <div style={{ marginBottom: "16px" }}>
              <KeyOutlined
                style={{
                  fontSize: "15px",
                  color: isSelected ? "#128555" : "#0070D7",
                  padding: "12px",
                  backgroundColor: isSelected ? "#EAF9F2" : "#f0f7ff",
                  borderRadius: "50%",
                  border: `3px solid ${isSelected ? "#128555" : "#0070D7"}`,
                  transition: "all 0.3s ease",
                }}
              />
            </div>

            {/* Permission Code */}
            <div style={{ marginBottom: "8px", width: "100%" }}>
              <Text
                code
                style={{
                  fontSize: "11px",
                  fontWeight: "600",
                  color: isSelected ? "#128555" : "#0070D7",
                  backgroundColor: isSelected ? "#EAF9F2" : "#f0f7ff",
                  padding: "4px 8px",
                  borderRadius: "4px",
                  border: `1px solid ${isSelected ? "#B8E8D0" : "#d6e4ff"}`,
                  display: "block",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  maxWidth: "100%",
                  textAlign: "center",
                }}
                title={permission.name}
              >
                {permission.name}
              </Text>
            </div>

            {/* Title */}
            <div
              style={{
                minHeight: "40px",
                display: "flex",
                alignItems: "center",
              }}
            >
              <Text
                strong
                style={{
                  fontSize: "13px",
                  color: "#1E293B",
                  display: "-webkit-box",
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: "vertical",
                  overflow: "hidden",
                  lineHeight: "1.4",
                  textAlign: "center",
                }}
                title={permission.label}
              >
                {permission.label || "Không có mô tả"}
              </Text>
            </div>

            {/* Click hint */}
            <div style={{ marginTop: "12px" }}>
              <Text
                style={{
                  fontSize: "11px",
                  color: "#999",
                  fontStyle: "italic",
                }}
              >
                {isSelected ? "Click để bỏ chọn" : "Click để chọn"}
              </Text>
            </div>
          </div>
        </Card>
      </Col>
    );
  };

  return (
    <div
      style={{
        padding: "24px",
        backgroundColor: "#F8FAFC",
        minHeight: "100vh",
      }}
    >
      {/* Header */}
      <Card
        style={{
          borderRadius: "12px",
          marginBottom: "24px",
          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        }}
      >
        <Row align="middle" justify="space-between">
          <Col>
            <Space align="center">
              <SecurityScanOutlined
                style={{ fontSize: "24px", color: "#0070D7" }}
              />
              <Title level={3} style={{ margin: 0, color: "#1E293B" }}>
                Quản lý Permission
              </Title>
            </Space>
          </Col>
          <Col>
            <Space>
              <Button
                type="primary"
                ghost
                onClick={handleBulkSelect}
                disabled={stats.filtered === stats.selectedFromFiltered}
                style={{ borderRadius: "8px" }}
              >
                Chọn tất cả ({stats.filtered - stats.selectedFromFiltered})
              </Button>
              <Button
                danger
                ghost
                onClick={handleBulkRemove}
                disabled={stats.selectedFromFiltered === 0}
                style={{ borderRadius: "8px" }}
              >
                Bỏ chọn tất cả ({stats.selectedFromFiltered})
              </Button>
            </Space>
          </Col>
        </Row>

        <Divider style={{ margin: "16px 0" }} />

        {/* Statistics */}
        <Row gutter={16} style={{ marginBottom: "16px" }}>
          <Col xs={24} sm={6}>
            <div
              style={{
                textAlign: "center",
                padding: "12px",
                backgroundColor: "#f0f7ff",
                borderRadius: "8px",
                border: "1px solid #d6e4ff",
              }}
            >
              <div
                style={{
                  fontSize: "24px",
                  fontWeight: "bold",
                  color: "#0070D7",
                }}
              >
                {stats.total}
              </div>
              <div style={{ fontSize: "14px", color: "#666" }}>Tổng số</div>
            </div>
          </Col>
          <Col xs={24} sm={6}>
            <div
              style={{
                textAlign: "center",
                padding: "12px",
                backgroundColor: "#EAF9F2",
                borderRadius: "8px",
                border: "1px solid #B8E8D0",
              }}
            >
              <div
                style={{
                  fontSize: "24px",
                  fontWeight: "bold",
                  color: "#128555",
                }}
              >
                {stats.selected}
              </div>
              <div style={{ fontSize: "14px", color: "#666" }}>Đã chọn</div>
            </div>
          </Col>
          <Col xs={24} sm={6}>
            <div
              style={{
                textAlign: "center",
                padding: "12px",
                backgroundColor: "#FFF5E8",
                borderRadius: "8px",
                border: "1px solid #FFE0B8",
              }}
            >
              <div
                style={{
                  fontSize: "24px",
                  fontWeight: "bold",
                  color: "#A8681E",
                }}
              >
                {stats.available}
              </div>
              <div style={{ fontSize: "14px", color: "#666" }}>Có thể chọn</div>
            </div>
          </Col>
          <Col xs={24} sm={6}>
            <div
              style={{
                textAlign: "center",
                padding: "12px",
                backgroundColor: "#F0F1FF",
                borderRadius: "8px",
                border: "1px solid #d3adf7",
              }}
            >
              <div
                style={{
                  fontSize: "24px",
                  fontWeight: "bold",
                  color: "#656DC7",
                }}
              >
                {stats.filtered}
              </div>
              <div style={{ fontSize: "14px", color: "#666" }}>Hiển thị</div>
            </div>
          </Col>
        </Row>

        {/* Search */}
        <Input
          placeholder="🔍 Tìm kiếm theo mã permission hoặc mô tả..."
          prefix={<SearchOutlined style={{ color: "#94A3B8" }} />}
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          allowClear
          size="large"
          style={{
            borderRadius: "10px",
            fontSize: "14px",
          }}
        />
      </Card>

      {/* Permission Grid */}
      <Card
        loading={isLoading}
        style={{
          borderRadius: "12px",
          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
          minHeight: "400px",
        }}
      >
        {filteredPermissions.length === 0 && !isLoading ? (
          <Empty
            description="Không tìm thấy permission nào"
            image={Empty.PRESENTED_IMAGE_SIMPLE}
          />
        ) : (
          <Row gutter={[16, 16]} style={{ padding: "8px 0" }}>
            {filteredPermissions.map((permission, index) =>
              renderPermissionCard(permission, index)
            )}
          </Row>
        )}
      </Card>
    </div>
  );
};

export default ListPermissionAddToMenu;
